export enum OrientationType {
    Portrait,
    Landscape
}